import { sortBy } from 'lodash';

export default {
  getProductGroup: (state) => state.productGroup,
  productGroups: (state) => sortBy(state.productGroups, 'name'),
};
